'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Selectează ora'
};

exports['default'] = locale;